import ObjectWidgetSettings from './component'

export default ObjectWidgetSettings
